import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class PlatformCards {
    constructor(container) {
        this.container = container;
        this.heading = this.container.querySelector('.platform-cards__heading');

        this.cards = this.container.querySelectorAll('.platform-card');

        this.init();
    }

    init = () => {
        if (this.heading) {
            new SplitText(this.heading, { type: 'lines,words', linesClass: 'lineParent' });
            this.headingSplit = new SplitText(this.heading.querySelectorAll('.lineParent'), { type: 'lines,words' });

            gsap.fromTo(
                this.headingSplit.lines,
                { yPercent: 100 },
                {
                    yPercent: 0,
                    duration: 0.9,
                    ease: 'power3.out',
                    stagger: { each: 0.08, from: 'start' },
                    scrollTrigger: {
                        trigger: this.heading,
                        start: 'top 85%',
                    },
                    onComplete: () => {
                        this.headingSplit.revert();
                    },
                }
            );
        }

        if (this.cards.length) {

            gsap.fromTo(
                this.cards,
                { opacity: 0, y: 60 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    delay: .1,
                    ease: 'power3.out',
                    stagger: { each: 0.1, from: 'start' },
                    scrollTrigger: {
                        trigger: this.container,
                        start: 'top 85%',
                        //  markers: true
                    },
                }
            );
        }
    };
}
